module.exports = __webpack_public_path__ + "static/media/chili pepper.576b69da.png";